import React from 'react'
import './impressum.css'

const Impressum = () => {
    return (
        <div className="impContainer">
            <div class="head"></div>
            <div className="impTxt">
                <h2>Impressum</h2>
            </div>
            <div className="impTxt">
                <span>Herausgeberin:</span><br></br>
                Gruppe „Alte Gruene Zukunft“<br></br>
                Stadtteilladen Windscheidstr. 16<br></br>
                10627 Berlin 
            </div>
            <div className="impTxt">
                Jochen Lehnert<br></br>
                jochen.lehnert@t-online.de
            </div>
            <div className="impTxt">
                <span>ViSdP:</span><br></br>
                Jochen Lehnert<br></br>
                Stadtteilladen Windscheidstr. 16<br></br>
                10627 Berlin
            </div>
            <div className="impTxt">
                <span>Haftungshinweis:</span>
            </div>
            <div className="impTxt">
                Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung für die Inhalte externer  Links. Für deren Inhalt sind ausschließlich die Anbieter oder Betreiber der jeweiligen Websites verantwortlich.
            </div>
            <div className="impTxt">
                <span>Realisierung durch</span><br></br>
                Eigenerstellung
            </div>
            <div className="impTxt">
                <span>Datenschutzerklärung</span>
            </div>
            <div className="impTxt">
                Wir wissen, dass Sie dem Thema Datenschutz große Bedeutung beimessen. Deshalb ist uns der Schutz Ihrer persönlichen Daten ein wichtiges Anliegen..
            </div>
            <div className="impTxt">
                <span>Persönliche Daten</span><br></br>
                Persönliche Daten, die Sie uns elektronisch übermitteln, z.B. Ihren Namen, Postanschrift, E-Mail-Adresse oder andere persönlichen Angaben, werden von uns nur zum jeweils angegebenen Zweck,  insbesondere zur Unterschrift des Aufrufs, verwendet. Darüber hinausgehende Informationen werden sicher verwahrt und nicht an Dritte weitergegeben. Wir werden Ihnen nur Informationen zuschicken, sofern Sie entsprechende Bitten an uns richten.
            </div>
            <div className="impTxt">
                <span>Recht auf Widerruf</span><br></br>
                Sie haben jederzeit das Recht auf Widerruf; schicken Sie bitte eine Mail an uns. Ich werde Ihre Daten dann umgehend löschen.
            </div>
            <div className="impTxt">
                <span>Links zu anderen Websites</span><br></br>
                Sie finden auf unseren Seiten Links zu anderen Seiten im Internet. Für alle diese Links und Banner gilt, dass ich keinerlei Einfluss auf die Gestaltung und die Inhalte der gelinkten Seiten haben. Deswegen übernehmen wir auch keinerlei Verantwortung für Inhalt, Gestaltung und die Datenschutzbestimmungen dieser Seiten.
            </div>
            <div className="impTxt">
                <span>Verwendung von Cookies</span><br></br>
                Es gibt eine Technik, genannt "Cookies", mit deren Hilfe Informationen aus einer Website an Ihre Bedürfnisse angepasst werden können. Ein Cookie ist ein Datenelement, das eine Website an Ihren Browser schicken kann, um es dort auf Ihrem System zu speichern.
            </div>
            <div className="impTxt">
                Gelegentlich nutzen auch wir temporäre Cookies, damit wir Sie effektiver unterstützen können, wenn Sie auf eine solche Website zurückkommen oder um Formulare, vor Missbrauch und SPAM zu schützen. Sie haben jedoch die Möglichkeit, Ihren Browser so einzustellen, dass er Sie davon in Kenntnis setzt, wenn Sie ein Cookie erhalten. Dann können Sie selbst entscheiden, ob Sie das akzeptieren wollen oder nicht.
            </div>
            <div class="Footer"></div>
        </div>
    )
}

export default Impressum
